import type { Chain } from '../../chain';
import type { WalletCreationRequirement } from '../waas.types';

/**
 * Type guard to check if an item is a WalletCreationRequirement object.
 * Chain values are strings, so we can distinguish by checking if it's an object with a 'chain' property.
 *
 * @param item - The item to check, either a WalletCreationRequirement or Chain string
 * @returns True if the item is a WalletCreationRequirement object
 */
export const isWalletCreationRequirement = (
  item: WalletCreationRequirement | Chain
): item is WalletCreationRequirement =>
  typeof item === 'object' && item !== null && 'chain' in item;
